import { render, staticRenderFns } from "./risAssessment.vue?vue&type=template&id=13fcf863&scoped=true&"
import script from "./risAssessment.vue?vue&type=script&lang=js&"
export * from "./risAssessment.vue?vue&type=script&lang=js&"
import style0 from "./risAssessment.vue?vue&type=style&index=0&id=13fcf863&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fcf863",
  null
  
)

export default component.exports